import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=19c7dc4a&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=19c7dc4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c7dc4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19c7dc4a')) {
      api.createRecord('19c7dc4a', component.options)
    } else {
      api.reload('19c7dc4a', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=19c7dc4a&scoped=true", function () {
      api.rerender('19c7dc4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/Tabs.vue"
export default component.exports